import { render } from "./Mandate.vue?vue&type=template&id=48b19130"
import script from "./Mandate.vue?vue&type=script&lang=js"
export * from "./Mandate.vue?vue&type=script&lang=js"

import exportComponent from "/opt/boarddata/boarddata.io/django/templates/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__